var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menuBar"},_vm._l((_vm.menuList),function(menu){return _c('div',{key:menu.key,class:{ active: _vm.selectedMenu == menu.route },on:{"click":function($event){return _vm.clickMenu(menu.route)}}},[_vm._v(" "+_vm._s(menu.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }